import React, { Component, createRef, PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Button, Grid, IconButton, Paper, Tab, Tabs, Tooltip, withStyles } from '@material-ui/core'

import { sortArrayByName } from '../../utils/array'
import { getShopList } from '../../actions/shop'

import WmDispatchShopInfoSettings from './WmDispatchShopInfoSettings'
import WmDispatchShopInfoEmployees from './WmDispatchShopInfoEmployees'
import WmDispatchShopInfoVehicles from './WmDispatchShopInfoVehicles'
import WmDispatchShopInfoErrorLogs from './WmDispatchShopInfoErrorLogs'
import { Link } from 'react-router-dom'

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import InfoIcon from '@material-ui/icons/Info'
import { WmDispatchLogo } from '../../assets'
import ModalDialog from '../common/ModalDialog'

import { Appcues } from '../../utils/constants'
import { openErrorMessage, openSuccessMessage } from '../../actions/message'
import {
  createDCHSettings,
  getDCHSettingsByCompanyId,
  createInternalWorkerOnDispatch,
  createWorkerOnDispatch,
  getDCHEmployeesByCompany,
  getDCHEmployeesByCompanyIdAndShopId,
  getWorkerByProvider,
  syncWorkerOnDispatch,
  removeWorkerOnDispatch,
  deleteEmployeeOnDispatch,
  getDCHCredentialByShopId,
  getDriversByAssignedShop,
} from '../../actions/dispatch'
import { getEmployeeList } from '../../actions/integration'

const shopTabs = [
  'Settings',
  'Employees',
  //"Vehicles",
  //"Error Logs"
]

const HelpTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#1cc4e8',
    color: '#fff',
    fontSize: theme.typography.pxToRem(13),
    maxWidth: 380,
  },
}))(Tooltip)

class WmDispatchShopInfo extends Component {
  state = {
    shopId: '',
    enableAddShop: false,
    activeTab: 'Settings',
    shopDispatch: {},
    shopInfo: {},
    addShopId: '',
    dchEmployees: [],
    dchCompanyEmployees: [],
    dchSettings: [],
  }

  shopConfirmModal = createRef()

  componentDidMount() {
    let companyId = JSON.parse(localStorage.getItem('session')).company.id
    let loc = this.props.location.pathname.split('/')
    if (loc[loc.length - 1] === 'add') {
      this.setState({ shopId: '', enableAddShop: true })
    } else {
      this.setState({ shopId: loc[loc.length - 1], enableAddShop: false })
      this.props.dispatch(getDCHSettingsByCompanyId(companyId))
      this.props.dispatch(getShopList())
      this.props.dispatch(getEmployeeList())
      this.props.dispatch(getDriversByAssignedShop(loc[loc.length - 1]))
      this.props.dispatch(getDCHEmployeesByCompany(companyId)).then((res) => {
        let dchEmployeesShop = res.filter((e) => {
          return e.shopId === loc[loc.length - 1]
        })
        this.setState({
          dchEmployees: dchEmployeesShop || [],
          dchCompanyEmployees: res || [],
        })
      })
      this.props.dispatch(
        getDCHCredentialByShopId({
          companyId,
          shopId: loc[loc.length - 1],
          provider: 'wmDispatch',
        }),
      )
    }
  }

  shopTabs = (enableAddShop) => {
    return shopTabs.map((tab) => <Tab label={tab} value={tab} disabled={enableAddShop} />)
  }

  linkWorker = (id, driverId, afterOnSave) => {
    let companyId = JSON.parse(localStorage.getItem('session')).company.id
    const { shopId } = this.state

    this.props
      .dispatch(syncWorkerOnDispatch({ id, shopId, driverId, companyId, provider: 'wmDispatch' }))
      .then((response) => {
        if (response.workerId === null && response.synced === false) {
          this.props.dispatch(openErrorMessage(`We couldn't link the employee to the workers`))
          afterOnSave()
        } else {
          this.props.dispatch(getDCHEmployeesByCompany(companyId)).then((res) => {
            let dchEmployeesShop = res.filter((e) => {
              return e.shopId === shopId
            })
            this.setState({
              dchEmployees: dchEmployeesShop || [],
              dchCompanyEmployees: res || [],
            })
            afterOnSave()
          })
        }
      })
  }

  getWorkers = (callback) => {
    let companyId = JSON.parse(localStorage.getItem('session')).company.id
    const { shopId } = this.state

    this.props
      .dispatch(
        getWorkerByProvider({ companyId: companyId, shopId: shopId, provider: 'wmDispatch' }),
      )
      .then((res) => {
        callback(res)
      })
  }

  createNewWorker = (request, afterOnSave) => {
    const { employeeList = {} } = this.props.integrationReducer
    const { shopsList = [] } = this.props.shopReducer
    const { shopId } = this.state
    let employeeListValues = employeeList.values || []
    let shopsListValues = shopsList.values || []
    let employeeListDriver = employeeListValues.filter((e) => e.driver)
    let driver = employeeListDriver.find((e) => e.id === request.employeeId)

    if (!driver.address.address || !driver.address.city || !driver.address.state) {
      const shopInfo = shopsListValues.find((e) => e.id === shopId)

      driver.address.address = shopInfo && shopInfo.address && shopInfo.address.address
      driver.address.city = shopInfo && shopInfo.address && shopInfo.address.city
      driver.address.state = shopInfo && shopInfo.address && shopInfo.address.state
    }

    driver.shopId = shopId
    this.props.dispatch(createWorkerOnDispatch({ driver, provider: 'wmDispatch' })).then((res) => {
      Appcues.track('New Worker created')
      afterOnSave(res)
    })
  }

  createNewInternalWorker = (request, afterOnSave) => {
    this.props.dispatch(createInternalWorkerOnDispatch({ request })).then((res) => {
      Appcues.track('New Worker created')
      afterOnSave(res)
    })
  }

  removeWorker = (employeeId, afterOnSave) => {
    let companyId = JSON.parse(localStorage.getItem('session')).company.id
    const { shopId } = this.state

    this.props
      .dispatch(removeWorkerOnDispatch({ request: employeeId, provider: 'wmDispatch' }))
      .then((response) => {
        if (response) {
          this.props.dispatch(getDCHEmployeesByCompany(companyId)).then((res) => {
            let dchEmployeesShop = res.filter((e) => {
              return e.shopId === shopId
            })
            this.setState({
              dchEmployees: dchEmployeesShop || [],
              dchCompanyEmployees: res || [],
            })
            afterOnSave()
          })
        }
      })
  }

  deleteEmployee = (employeeId, afterOnSave) => {
    let companyId = JSON.parse(localStorage.getItem('session')).company.id
    const { shopId } = this.state

    this.props
      .dispatch(
        deleteEmployeeOnDispatch({
          request: {
            id: employeeId,
            companyId: companyId,
          },
          provider: 'wmDispatch',
        }),
      )
      .then((response) => {
        this.props.dispatch(getDCHEmployeesByCompany(companyId)).then((res) => {
          let dchEmployeesShop = res.filter((e) => {
            return e.shopId === shopId
          })
          this.setState({
            dchEmployees: dchEmployeesShop || [],
            dchCompanyEmployees: res || [],
          })
          afterOnSave()
        })
      })
  }

  handleChange = (event, tab) => {
    this.setState({
      activeTab: tab,
    })
  }

  onError = (message) => this.props.dispatch(openErrorMessage(message))
  onSuccess = (message) => this.props.dispatch(openSuccessMessage(message))

  addShop = () => {
    const { addShopId } = this.state
    let companyId = JSON.parse(localStorage.getItem('session')).company.id
    const request = {
      companyId: companyId,
      shopId: addShopId,
    }
    this.props.dispatch(createDCHSettings({ request, provider: 'wmDispatch' })).then((res) => {
      this.props.dispatch(getDCHSettingsByCompanyId(companyId)).then((res) => {
        this.setState({ enableAddShop: false })
        this.shopConfirmModal.current.handleClose()
        window.location.href = `/settings/integration/wmDispatch/${addShopId}`
      })
    })
  }

  operAddShopModal = (shopId) => {
    if (shopId === '' || shopId == null) {
      this.onError('Please provide a valid shop name')
    } else {
      this.setState({ addShopId: shopId })
      this.shopConfirmModal.current.handleClickOpen()
    }
  }

  cancelShop = () => {
    this.props.history.push(`/settings/integration/wmDispatch`)
  }

  getShopInfo = (shopId, shopsList, shopDispatchList) => {
    const shopDCH = shopDispatchList.filter((element) => {
      return element.shopId === shopId
    })
    const shopInfo = shopsList.filter((element) => {
      return element.id === shopId
    })

    return [shopDCH.length > 0 ? shopDCH[0] : null, shopInfo.length > 0 ? shopInfo[0] : null]
  }

  renderTab = (activeTab) => {
    const { shopId, enableAddShop, dchEmployees, dchCompanyEmployees } = this.state
    const { shopsList = [] } = this.props.shopReducer
    const {
      msDispatchSettingsList = [],
      msDispatchCredential = {},
      driverList = {},
    } = this.props.dispatchReducer

    const [shopDispatch, shopInfo] = this.getShopInfo(
      shopId,
      shopsList.values || [],
      msDispatchSettingsList || [],
    )
    let employeeListDriver = (driverList && driverList.values) || []

    employeeListDriver = sortArrayByName(
      employeeListDriver.map((employee) => ({
        ...employee,
        name: `${employee.firstName} ${employee.lastName}`,
      })),
    )

    switch (activeTab) {
      case 'Settings':
        return (
          <WmDispatchShopInfoSettings
            shopInfo={shopInfo}
            shopDispatch={shopDispatch}
            shopCredential={msDispatchCredential}
            shopsList={shopsList.values || []}
            settingsList={msDispatchSettingsList || []}
            operAddShopModal={this.operAddShopModal}
            cancelShop={this.cancelShop}
            enableAddShop={enableAddShop}
            onError={this.onError}
            onSuccess={this.onSuccess}
          />
        )
      case 'Employees':
        return (
          <WmDispatchShopInfoEmployees
            employeeList={employeeListDriver}
            shopInfo={shopInfo}
            dchCompanyEmployees={dchCompanyEmployees}
            dchEmployees={dchEmployees}
            getWorkers={this.getWorkers}
            linkWorker={this.linkWorker}
            removeWorker={this.removeWorker}
            deleteEmployee={this.deleteEmployee}
            createNewWorker={this.createNewWorker}
            createNewInternalWorker={this.createNewInternalWorker}
            shopsList={shopsList}
            shopId={shopId}
          />
        )
      case 'Vehicles':
        return <WmDispatchShopInfoVehicles shopInfo={shopInfo} />
      case 'Error Logs':
        return <WmDispatchShopInfoErrorLogs shopInfo={shopInfo} />
      default:
        return null
    }
  }

  render() {
    const { shopId = '', activeTab, enableAddShop } = this.state
    const { msDispatchSettingsList = [] } = this.props.dispatchReducer
    const { shopsList } = this.props.shopReducer
    const [shopDispatch, shopInfo] = this.getShopInfo(
      shopId,
      shopsList.values || [],
      msDispatchSettingsList || [],
    )

    return (
      <div>
        <div>
          <ul className="breadcrumb">
            <li>Integrations</li>
            <li>
              {' '}
              <Link
                to={{
                  pathname: '/settings/integration/wmDispatch',
                }}
                className="link-hover"
              >
                WM Dispatch
              </Link>
            </li>
            <li>{shopInfo ? shopInfo.name : null}</li>
          </ul>
        </div>
        <div style={{ marginTop: '2rem' }}>
          <Grid container>
            <Grid item xs={12} sm={2} style={{ paddingTop: '.6rem' }}>
              <Button className="btn-border" onClick={this.cancelShop}>
                {' '}
                <ChevronLeftIcon /> Back
              </Button>
            </Grid>
            <Grid item xs={12} sm={7} centered>
              <Tabs
                value={activeTab}
                onChange={this.handleChange}
                indicatorColor="primary"
                textColor="primary"
                centered
              >
                {this.shopTabs(enableAddShop)}
              </Tabs>
            </Grid>
            <Grid item xs={12} sm={3} className="info-align">
              <div style={{ paddingTop: '.2rem', marginRight: '1rem' }}>
                <img
                  src={WmDispatchLogo}
                  height={35}
                  width={18}
                  style={{ paddingRight: '1.5rem' }}
                />
                <HelpTooltip
                  title={
                    <div>
                      Support Phone: 1-844-933-3627
                      <br />
                      M-F 6am-6pm / Sa 7am-4pm PST
                    </div>
                  }
                  placement="bottom-end"
                >
                  <IconButton className="iconinfo">
                    <InfoIcon className="info" />
                  </IconButton>
                </HelpTooltip>
              </div>
            </Grid>
          </Grid>
          <Paper elevation={0} className={`tab-paper`}>
            {this.renderTab(activeTab)}
          </Paper>
        </div>
        <ModalDialog
          title={'Shop Confirm'}
          ref={this.shopConfirmModal}
          onConfirm={this.addShop}
          confirmText="Confirm"
        >
          <div> Are you sure you want to assign the WM Dispatch integration to this shop?</div>
        </ModalDialog>
      </div>
    )
  }
}

const WmDispatchShopViewConnected = connect(
  ({ shopReducer, integrationReducer, dispatchReducer, dispatch }) => ({
    shopReducer,
    integrationReducer,
    dispatchReducer,
    dispatch,
  }),
)(WmDispatchShopInfo)

export default withRouter(WmDispatchShopViewConnected)



// WEBPACK FOOTER //
// ./src/components/WmDispatch/WmDispatchShopInfo.js